import React, { useState } from 'react'
import moment from 'moment';
import { hashHistory } from 'react-router';
import Grid from "@material-ui/core/Grid";
import { useStyle } from "./Style";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Claims from '../CustomerClaimsTable/Claims';



const ClaimInitiationWrapper = (props) => {
  const steps =  ['Step 1', 'Step 2', 'Step 3', 'Step 4', 'step 5', 'Step 6']

  const tabIndex = {
    selectPolicy: 0,
    selectMember: 1,
    AdditionalDetails: 2,
    ClaimLogging: 3,
    claimSummary: 4,
    claimDetails: 5,
  };

  const classes = useStyle();
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleStep = step => () => {
    setActiveStep(step);
  };

  const getLabel = () => {
   if (completedSteps() === totalSteps() - 1)
      return "All Done";

    if (activeStep === tabIndex.ClaimLogging)
      return "View  Claim Summary";
    if (activeStep === tabIndex.claimSummary)
      return "Submit Claim ";
    return "Next";
  };

  const isBackDisabled = () => {
    // Disable back button on first step
    return activeStep === 0;
  };

  const isDisabled = () => {
    if (activeStep === tabIndex.selectPolicy && !props.eventQuote) return true;
    if (
      activeStep === tabIndex.selectMember &&
      (!props.eventQuote ||
        !props.claimPayload.claimInitiationPayload.member ||
        !props.claimPayload.claimInitiationPayload.benefits)
    )
      return true;
    if (props.hasHospiCashAccidentBenefit || props.hasHospiCashIllnessBenefit) {
      if (
        activeStep === tabIndex.AdditionalDetails &&
        (!props.admissionDate ||
          !props.dischargeDate ||
          !props.hospital_attended ||
          !props.cause_of_hospitilization ||
          !props.inpatient_number ||
          !props.number_of_days_in_hospital)
      ) {
        return true;
      }

      // Check for 72-hour minimum requirement
      if (props.admissionDate && props.dischargeDate) {
        const hours = moment(props.dischargeDate).diff(moment(props.admissionDate), 'hours');
        if (hours < 72) {
          return true;
        }
      }
    }

    if (props.hasAccidentalDeathBenefits && activeStep === tabIndex.AdditionalDetails) {
      if (!props.claimPayload.type_of_claim) return true;
    }

    if (activeStep === tabIndex.AdditionalDetails) {
      const claimState = props.claimPayload;

      if (claimState.type_of_claim === 'Accidental Disability') {
        if (!(claimState.date_of_disability || claimState.claimInitiationPayload.event_date) ||
            !claimState.type_of_disability ||
            !claimState.attending_physician) {
          return true;
        }
      }

      if (claimState.type_of_claim === 'Accidental Death') {
        if (!claimState.cause_of_death ||
            !claimState.funeral_home_name ||
            !claimState.death_certficate_number) {
          return true;
        }
      }
    }

    if (props.hasRoadsideAssistanceBenefit && activeStep === tabIndex.AdditionalDetails) {
      const claimState = props.claimPayload;
      const assistanceType = claimState.assistance_type;
      const hasAssistanceType = assistanceType && (
        Array.isArray(assistanceType) ? assistanceType.length > 0 : !!assistanceType
      );
      if (!claimState.car_registration ||
          !claimState.incident_location ||
          !claimState.incident_time ||
          !hasAssistanceType ||
          !claimState.carrying_status) {
        return true;
      }
      if (Array.isArray(assistanceType) && assistanceType.includes('Towing Services')) {
        if (!claimState.estimated_distance_towed) return true;
      }
    }

    if ((props.hasLegalExpenseBenefit || props.hasBDFandPrisonsBenefit) &&
        activeStep === tabIndex.AdditionalDetails) {
      const claimState = props.claimPayload;
      if (!claimState.nature_of_case ||
          !claimState.type_of_dispute ||
          !claimState.brief_description) {
        return true;
      }

      const waitingPeriodTypes = ['Divorce', 'Agreement of sale', 'Deceased estate planning'];
      if (waitingPeriodTypes.indexOf(claimState.type_of_dispute) !== -1) {
        const policyStartDate = props.eventQuote && props.eventQuote.start_date;
        const eventDate = claimState.claimInitiationPayload.event_date;
        if (policyStartDate && eventDate &&
            moment(eventDate).diff(moment(policyStartDate), 'months') < 6) {
          return true;
        }
      }
    }

    if (activeStep === tabIndex.ClaimLogging) {
      const claimantData = props.claimPayload;

      if (!claimantData.claimant_full_name ||
          !claimantData.claimant_id_number ||
          !claimantData.claimant_phone_number ||
          !claimantData.claimant_relationship_to_patient ||
          !claimantData.claimant_email) {
        return true;
      }

      if (!props.hasLegalExpenseBenefit && !props.hasBDFandPrisonsBenefit) {
        if (!claimantData.claimant_payment_option) return true;

        if (claimantData.claimant_payment_option === 'Bank') {
          if (!claimantData.claimant_bank_name ||
              !claimantData.claimant_bank_branch ||
              !claimantData.claimant_bank_account_number) {
            return true;
          }
        }

        if (claimantData.claimant_payment_option === 'Orange Money' ||
            claimantData.claimant_payment_option === 'Myzaka' ||
            claimantData.claimant_payment_option === 'Smega') {
          if (!claimantData.claimant_mobile_money_number) return true;
        }

        if (claimantData.claimant_payment_option === 'Smega') {
          if (!claimantData.claimant_omang_number) return true;
        }
      }
    }
    return false;
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);

    if(activeStep === tabIndex.ClaimLogging) {
      props.handleClaimSummary();
      // return
    }



    if(activeStep === tabIndex.claimSummary) {
      props.handleInitiateClaim();
      // return
    }

    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const getClaimComponents = () => {

    if (activeStep === tabIndex.selectPolicy) return {
      component: props.components.SelectPolicy
    }
    if (activeStep === tabIndex.selectMember) return {
      component: props.components.SelectMember
    }
    if (activeStep === tabIndex.ClaimLogging) return {
      component: props.components.ClaimLoggingDetails
    }

    if (activeStep === tabIndex.AdditionalDetails) return {
      component: props.components.AdditionalDetails
    }

    if (activeStep === tabIndex.claimSummary) return {
      component: props.components.ClaimSummary
    }

    if (activeStep === tabIndex.claimDetails) return {
      component: props.components.ClaimDetails
    }
  }

  const renderClaimComponent = () => {
    const claimComponent = getClaimComponents();
    return <div>
      <Box
        component="form"
        sx={{
          '& .MuiTextField-root': { m: 1, width: '25ch' },
        }}
        noValidate
        autoComplete="off"
      >
        <>
          {claimComponent.component}
        </>
      </Box>
    </div>
  }
  return (
    <>
      <Grid item xs={12} md={9} sm={9}>
        <section className={classes.ClaimInitiationWrapper}>
          <Box sx={{ width: '100%' }}>
            <div className={classes.stepperlabelwrapper}>
              <Stepper  activeStep={activeStep}>
                {steps.map((label, index) => (
                  <Step key={label} completed={completed[index]} sx={{
                    '& .MuiStepLabel-root .Mui-completed': {
                      color: '#75A85E', // circle color (COMPLETED)
                    },
                    '& .MuiStepLabel-root .Mui-active': {
                      color: '#032a37', // circle color (ACTIVE)
                    },
                    '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                      fill: '#fff', // circle's number (ACTIVE)
                    },
                  }}>
                    <StepButton color="inherit" onClick={handleStep(index)}>
                      {label}
                    </StepButton>
                  </Step>
                ))}
              </Stepper>
            </div>

            <div>
              {allStepsCompleted() ? (
                <>
                  <div className={classes.claimnavigationbtn} style={{ textAlign: 'center' }}>
                    <p >
                      What would you like to do next
                    </p>
                    <br/>
                    <br/>
                    <Button
                      variant="contained"
                      size="large"
                      onClick={handleReset}
                    >Generate Another Claim</Button>
                    <Button
                      variant="contained"
                      size="large"
                      onClick={()=> hashHistory.push(`admin/claim-processing-v2/${props.createdClaim.guid}`)}
                    // className={classes.viewquote}
                    >View Claim</Button>
                  </div>
                </>
              ) : (
                <>
                  <div className={classes.claimsinitiatewrapper}>

                    {renderClaimComponent()}
                  </div>
                  <div className={classes.claimnavigationbtn}>
                    <Button
                      disabled={isBackDisabled()} 
                      onClick={handleBack}
                      className={classes.backbtn}
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      onClick={handleComplete}
                      disabled={isDisabled()}
                    >
                      { getLabel()}
                    </Button>
                  </div>
                </>
              )}
            </div>


          </Box>
        </section>
        <section>
          <Claims customerClaimsDcp={props.customerClaimsDcp}/>
        </section>
      </Grid>
    </>
  )
}

export default ClaimInitiationWrapper